import { MessageBusEvents } from '../common/constants/message-bus-events';
import { RxEmitterInstance } from 'common/rxjs/rx-emitter';
import { Injectable } from '@angular/core';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';
import { OutgoingChatMessageFactory } from 'common/outgoing-chat-message-factory/outgoing-chat-message-factory.service';
import { BcRestApi } from 'common/api/rest-api';
import { ChatMessage } from 'common/xislivechat/models/chat-message';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryObservable } from 'common/dynamicquery/dynamic-query-observable.model';

@Injectable({
  providedIn: 'root'
})
export class ChatMessagesService {
  private readonly _rxEmitter = RxEmitterInstance;

  constructor(private readonly dynamicQuery: DynamicQueryAdapterService,
              private readonly decorator: DynamicQueryDecoratorService,
              private readonly outgoingChatMessageFactory: OutgoingChatMessageFactory,
              private readonly bcRestApi: BcRestApi) {
  }

  observePastMessagesByChatId(chatId): DynamicQueryObservable<ChatMessage> {
    if (!chatId) {
      throw new Error('Missing chatId');
    }

    const messagesObservable = this.dynamicQuery.getQuery('chatMessagesByChatID', { ChatID: chatId });
    return this.decorator.create(messagesObservable, ChatMessage.wrap);
  }

  sendMessage(chatMessage) {
    const outgoingChatMessage = this.outgoingChatMessageFactory.createChatMessage(chatMessage);
    return this.bcRestApi.sendMessage(outgoingChatMessage);
  }

  public addMessageToQueue(chatId: string, chatMessage): void {
    const outgoingChatMessage = this.outgoingChatMessageFactory.createChatMessage(chatMessage);
    this._rxEmitter.send(`${MessageBusEvents.ChatMessagesQueue}${chatId}`, outgoingChatMessage);
  }

  getChatMessages(chatId) {
    return this.bcRestApi.getChatMessages(chatId)
      .then(messages => {
        return Array.from(messages, (msg: any) => ChatMessage.wrap({
          // This property transformation is required, because the REST API returns JavaScript-friendly property
          // names, but the ChatMessage model class is also used for the results of dynamic queries.
          data: {
            ChatMessageID: msg.id,
            Name: msg.name,
            PersonID: msg.personId,
            PersonType: msg.personType,
            Created: msg.createdAt,
            Text: msg.text
          }
        }));
      });
  }
}
